// @ts-nocheck
import type React from 'react';

import { Button } from '@cobliteam/ui/components';
import { Divider } from '@cobliteam/ui/components';
import { TablePagination as BaseTablePagination, type LabelDisplayedRowsArgs, type TablePaginationProps, withStyles } from '@material-ui/core';
import { TablePaginationActions } from './TablePaginationActions';
import { pagination, paginationWrapper, paperStyle } from './styles';

import Icon from '@cobliteam/ui/icons';

import { colors, fonts } from '../../styles';

const StyledTablePagination = withStyles({
  root: {
    borderBottom: 'none',
    display: 'flex',
    flexDirection: 'row-reverse',
    height: 56,
  },
  selectRoot: {
    marginRight: 40,
  },
  select: {
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.medium,
    lineHeight: '19px',
    color: colors.gray.dark,
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&&': {
      padding: '7px 21px 7px 2px',
    },
  },
  selectIcon: {
    color: colors.gray.dark,
    top: 'unset',
    height: 16,
    width: 16,
  },
  caption: {
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.light,
    lineHeight: '19px',
    color: colors.black,
  },
  toolbar: {
    paddingRight: 10,
  },
  menuItem: {
    color: colors.gray.dark,
    fontWeight: fonts.weight.medium,
    fontSize: fonts.size.small,
    lineHeight: '19px',
    textAlign: 'center',
    display: 'block',
    padding: '10px 20px',
    '&&': {
      backgroundColor: colors.white,
      '&:hover': {
        backgroundColor: colors.gray.lightest,
      },
      '&:focus': {
        backgroundColor: colors.custom.lightGray50,
      },
    },
  },
})((props: TablePaginationProps) => <BaseTablePagination component='div' {...props} />);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const TablePagination: React.FC<
  TablePaginationProps & { onCallbackPaginationButton?: () => void } & {
    hiddenDivider?: boolean;
  }
> = ({ count: numberOfRows, page: currentPage, rowsPerPage, hiddenDivider, onChangePage, onChangeRowsPerPage, onCallbackPaginationButton, ...otherProps }) => {
  const rowsPerPageOptions = [10, 25, 50, 100];
  const labelDisplayedRows = (args: LabelDisplayedRowsArgs) => `${args.from} - ${args.to} de ${args.count}`;

  return (
    <div className={paginationWrapper}>
      {!hiddenDivider && <Divider />}

      <div className={pagination}>
        <div>
          {onCallbackPaginationButton ? (
            <Button variant='text' startIcon={<Icon name='mail' />} onClick={onCallbackPaginationButton}>
              Enviar feedback
            </Button>
          ) : null}
        </div>
        <StyledTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          labelRowsPerPage='Linhas por página:'
          labelDisplayedRows={labelDisplayedRows}
          count={numberOfRows}
          rowsPerPage={rowsPerPage || rowsPerPageOptions}
          page={currentPage}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          SelectProps={{
            MenuProps: { classes: { paper: paperStyle } },
            IconComponent: () => <Icon name='chevron-down' />,
          }}
          {...otherProps}
        />
      </div>
    </div>
  );
};
